<button inProgress [disableProgress]="disableProgress" [type]="type" [tabindex]="tabIdx" [class]="styleClass"
    [ngClass]="ngStyleClass" [ngClass]="{'btn-disabled' : disabled}" [disabled]="disabled || isInProgress"
    (click)="onClickEvent()">
    <ng-content></ng-content>
</button>